import type { NullableValues, ReadonlyRecord } from '../utils'

import type { PaginationParameters } from '.'

export type CustomizedTable<Line extends ReadonlyRecord<string, unknown>> = NullableValues<Pick<PaginationParameters<Line>, 'search' | 'sort'>> &
    PaginationParameters<Line>['pagination']
